import { Nullable } from './Types';

export const referenceToString = (it: { name: string }): string => it.name;
export const referenceToKey = (it: { code: string }): string => it.code;

export const lookupIdentifierToName = (it: Nullable<{ name?: string }>): string => it?.name || '';
export const lookupIdentifierToKey = (it: Nullable<{ id: string }>): string => it?.id || 'keyMissing';
export const compareLookupIdentifiers = (a: Nullable<LookupIdentifier>, b: Nullable<LookupIdentifier>): boolean =>
    a?.id === b?.id;

export const convertToLookUpIdentifier = (it: LookupIdentifier): LookupIdentifier => {
    return {
        id: it.id,
        authoringSystem: it.authoringSystem,
        authoringSystemForeignKey: it.authoringSystemForeignKey
    };
};

export function isLookupIdentifier<T>(thing: T | LookupIdentifier): thing is LookupIdentifier {
    return (thing as LookupIdentifier).name !== undefined;
}

export interface Reference {
    code: string;
    name: string;
    codingSystemUri?: string;
    codingSystemVersion?: string;
    codingSystemValue?: string;
}

export type OrderedReference = Reference & {
    orderNumber: number;
};

export interface LookupIdentifier {
    id: string;
    name?: string;
    authoringSystem: string;
    authoringSystemForeignKey: string;
}
